/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IApiList, IPayout } from '../../../types';
import { Payouts } from './types';

const initialState: IApiList<IPayout> | null = null;

export const payoutsReducer: Reducer<IApiList<IPayout> | null> = (state = initialState, action) => {
  switch (action.type) {
    case Payouts.GET_SITE_PAYOUTS_REQUEST:
    case Payouts.GET_EMPLOYEE_PAYOUTS_REQUEST:
    case Payouts.GET_USER_PAYOUTS_REQUEST:
    case Payouts.GET_SITE_REVIEW_PAYOUTS_REQUEST:
    case Payouts.GET_SITE_EMPLOYEE_PAYOUTS_REQUEST: {
      return null;
    }
    case Payouts.GET_SITE_PAYOUTS_SUCCESS:
    case Payouts.GET_SITE_REVIEW_PAYOUTS_SUCCESS:
    case Payouts.GET_EMPLOYEE_PAYOUTS_SUCCESS:
    case Payouts.GET_USER_PAYOUTS_SUCCESS: {
      return action.payload;
    }
    case Payouts.GET_SITE_EMPLOYEE_PAYOUTS_SUCCESS: {
      const { employee, ...payouts } = action.payload;
      return payouts;
    }
    case Payouts.RETRY_PAYOUT_SUCCESS:
    case Payouts.CANCEL_PAYOUT_SUCCESS: {
      const payoutResponse = action.payload as IPayout;
      return {
        ...state,
        ...(state?.data && { data: state.data.map((p) => (p.id === payoutResponse.id ? payoutResponse : p)) }),
      };
    }
    default: {
      return state;
    }
  }
};
